import { FC, useState } from "react";
import {
  Modal,
  Backdrop,
  Fade,
  TextField,
  Button,
  DialogTitle,
} from "@material-ui/core";
import styled from "styled-components";

const StyledModalContainer = styled.div`
  position: absolute;
  width: 400px;
  background-color: white;
  border-radius: 8px;
  padding: 8px 16px 24px 16px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  outline: none;
  text-align: center;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
`;

const CancelButton = styled(Button)`
  && {
    background-color: #e0e0e0;
    color: black;
    font-weight: bold;
    width: 45%;
  }
`;

const ConfirmButton = styled(Button)`
  && {
    background-color: #f9a825;
    color: white;
    font-weight: bold;
    width: 45%;
  }
`;

interface ConfirmDeleteModalProps {
  total: number;
  open: boolean;
  onClose: () => void;
  onConfirm: (refundAmount: number) => void;
}

export const RefundSubscriptionModal: FC<ConfirmDeleteModalProps> = ({
  total,
  open,
  onClose,
  onConfirm,
}) => {
  const [refundAmount, setRefundAmount] = useState<number | "">(total);

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <StyledModalContainer>
          <DialogTitle>Оберіть суму повернення коштів</DialogTitle>
          <TextField
            label="Сума на повернення"
            type="number"
            fullWidth
            value={refundAmount}
            onChange={(e) => {
              let value = e.target.value;

              if (/^0[0-9]+/.test(value)) {
                value = value.replace(/^0+/, "");
              }

              const numberValue = Number(value);
              if (value === "" || (!isNaN(numberValue) && numberValue >= 0)) {
                setRefundAmount(value === "" ? "" : numberValue);
              }
            }}
            onKeyDown={(e) => {
              if (["-", "+", "e", "E"].includes(e.key)) {
                e.preventDefault();
              }
            }}
            variant="outlined"
            margin="none"
            inputProps={{ min: 0 }}
          />
          <ButtonRow>
            <CancelButton onClick={onClose}>ВІДМІНИТИ</CancelButton>
            <ConfirmButton onClick={() => onConfirm(Number(refundAmount))}>
              ПІДТВЕРДИТИ
            </ConfirmButton>
          </ButtonRow>
        </StyledModalContainer>
      </Fade>
    </Modal>
  );
};
